module.exports = __webpack_public_path__ + "static/banner-cfac5e91b21783ab8fbabd579be3a977.png";